export default __webpack_public_path__ + "static/media/Best-Bouquet.062d3816.jpg";